import { render, staticRenderFns } from "./CustomLandingPageForm.vue?vue&type=template&id=1a039f90"
import script from "./CustomLandingPageForm.vue?vue&type=script&lang=js"
export * from "./CustomLandingPageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports